import { Box, Button, Flex, HStack, Input, Text } from '@chakra-ui/react'
import { useMemo, useState } from 'react'
import ReactJson from 'react-json-view'
const Json = ('default' in ReactJson ? ReactJson.default : ReactJson) as typeof ReactJson

export const JsonViewer = ({ jsonString }: { jsonString: string }) => {
  const [collapsedLevel, setCollapsedLevel] = useState<number | false>(2)
  const [nextCollapseLevel, setNextCollapseLevel] = useState(collapsedLevel)

  const parsed = useMemo(() => {
    try {
      const result = JSON.parse(jsonString)

      if (typeof result === 'object' && result !== null) {
        return result
      }

      return null
    } catch {
      return null
    }
  }, [jsonString])

  return (
    <Box>
      {!parsed &&
        <Text wordBreak='break-word'>{jsonString}</Text>
      }

      {parsed &&
        <>
          <HStack spacing={4} mb={4}>
            <Button size="sm" colorScheme="green" onClick={() => setCollapsedLevel(nextCollapseLevel)}>
              Collapse to lvl. {nextCollapseLevel}
            </Button>
            <Button size="sm" colorScheme="green" onClick={() => setCollapsedLevel(false)}>
              Expand all
            </Button>

            <Flex ml='auto' alignItems='center'>
              <Text mr={2} fontSize="sm">Level:</Text>
              <Input
                size="sm"
                type="number"
                value={nextCollapseLevel.toString()}
                onChange={(e) => {
                  const value = e.target.value ? parseInt(e.target.value, 10) : 0
                  setNextCollapseLevel(value)
                  setCollapsedLevel(value)
                }}
                placeholder="Set collapse level"
                width="50px" />
            </Flex>

          </HStack>

          <Box bg="gray.50" borderRadius="md" p={4}>
            <Json
              src={parsed}
              name={false}
              collapsed={collapsedLevel}
              enableClipboard={true}
              displayDataTypes={false}
              displayObjectSize={false}
              style={{ fontSize: '14px' }}
            />
          </Box>
        </>
      }
    </Box>
  )
}